const EstadoCivilValues = [
  {
    label: 'Solteiro(a)',
    value: '1'
  },
  {
    label: 'Casado(a)',
    value: '2'
  },
  {
    label: 'Divorciado(a)',
    value: '3'
  },
  {
    label: 'Viúvo(a)',
    value: '4'
  }
];

export { EstadoCivilValues };
